/*
https://splidejs.com/guides/getting-started/
*/

import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

document.addEventListener( 'DOMContentLoaded', function () {

    if( document.querySelector( '.main-slider' ) ) {
        var main = new Splide( '.main-slider', {
            type: 'slider',
            rewind: true,
            pagination: false,
            arrows: false,
            start: 0,
            perPage: 1,
            perMove: 1,
            autoplay: true,
            interval: 4000,
            pause: false,
        } );
    
        var thumbnails = new Splide( '.thumbnail-slider', {
            fixedWidth : 54,
            fixedHeight: 54,
            rewind: true,
            pagination: false,
            isNavigation: true,
            start: 0,
            perPage: 7,
            perMove: 1,
            breakpoints : {
                // 600: {
                //     fixedWidth : 60,
                //     fixedHeight: 44,
                // },
            },
        } );
    
        main.sync( thumbnails );
        main.mount();
        thumbnails.mount();
    }
} );